import React from 'react'

import './coupon.less'
class Coupon extends React.Component<any, any> {
  constructor(props: any) {
    super(props)
    this.state = {
      show_detail: false,
    }
  }
  showClick = (value: any) => {
    this.setState({
      show_detail: value,
    })
  }
  render() {
    const { info, type } = this.props
    let iconDetail
    if (this.state.show_detail) {
      iconDetail = (
        <i onClick={() => this.showClick(false)} className="iconfont">
          &#xe62a;
        </i>
      )
    } else {
      iconDetail = (
        <i onClick={() => this.showClick(true)} className="iconfont">
          &#xe629;
        </i>
      )
    }

    return (
      <div key={info.id} className="item-coupon">
        {type === 'wait' && <i className="iconfont">&#xe66b;</i>}
        <span className="font-7 character-new">新</span>
        {//半透明
        type !== 'wait' && <div className="translucent" />}
        <div className="co-item">
          <div>
            <p
              className={`${
                type === 'wait' ? 'font-6 notice-color' : 'font-6'
              } text-ell price`}
            >
              ￥{info.price}
            </p>
            <p className="font-8 font_gray">{info.type}</p>
          </div>
          <div className="co-date">
            <p className="font-7 title ">{info.title}</p>
            <p className="font-8">
              {`${info.start_time}~${info.end_time}`}
              &nbsp;&nbsp;
              <span className="notice-color">{info.residue}</span>
            </p>
          </div>
        </div>
        {info.text && <p className="co-text notice-color">{info.text}</p>}

        <div>
          <div className="co-notice font-7">
            {info.is_limit ? '优惠券详细信息' : info.brief}
            {info.is_limit && iconDetail}
          </div>
          {info.is_limit && this.state.show_detail && (
            <div className="brief-detail font-8">{info.brief}</div>
          )}
        </div>

        {type !== 'wait' && (
          <img
            className="iconimg"
            src={`/public/assets/img/${
              type === 'used' ? 'used_coupon.png' : 'exp-coupon.png'
            }`}
            alt=""
          />
        )}
      </div>
    )
  }
}

export default Coupon
